import React, { useEffect } from "react"
import types from "prop-types"
import { useDispatch, useSelector } from "react-redux"
import {
  initialize as initializeSAMLConfigurationsSlice,
  loading as loadingSAMLConfigurations,
} from "reduxSlices/SAMLConfigurationsSlice"
import LoadingIndicator from "shared/LoadingIndicator"
import withReduxProvider from "shared/withReduxProvider"
import AddSAMLConfiguration from "./AddSAMLConfiguration"
import SAMLConfigurationsList from "./SAMLConfigurationsList"

const ManageSAMLConfigurations = ({ organizationSubdomain }) => {
  const dispatch = useDispatch()
  const loading = useSelector(loadingSAMLConfigurations)

  useEffect(() => {
    dispatch(initializeSAMLConfigurationsSlice({ organizationSubdomain }))
  }, [dispatch, organizationSubdomain])

  if (loading) {
    return (
      <LoadingIndicator textValue="Loading SAML configurations ..." />
    )
  }

  return (
    <div className="flex flex-col gap-4">
      <SAMLConfigurationsList />
      <AddSAMLConfiguration />
    </div>
  )
}

ManageSAMLConfigurations.propTypes = {
  organizationSubdomain: types.string.isRequired,
}

export default withReduxProvider(ManageSAMLConfigurations)
